import _ from 'underscore';
import { gmcSignInStatusSectionStyles } from './gmc-section-styles';
import { detailsListGridErrorText } from './shared-styles';

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
const multipleMatchingStoresDescriptionStyles = ({ iconFontFamily, palette }) => ({
  color: '#D83B01',
  marginTop: '8px',
  '& .iconba': {
    fontSize: '16px',
  },
  '& .text': {
    fontSize: '14px',
    marginLeft: '8px',
  },
});

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
const readOnlyCellStyles = ({ iconFontFamily, palette }) => ({
  borderBottom: '1px dashed #0078D4',
  textOverflow: 'ellipsis',
  wordBreak: 'break-word',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  verticalAlign: 'middle',
  cursor: 'pointer',
});

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
const dropdownStyles = ({ iconFontFamily, palette }) => ({
  width: '280px',
  height: '25px',
  cursor: 'pointer',
  paddingRight: '5px',
  paddingLeft: '10px',
  '& .selected-item': {
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    margin: '0 2px',
    float: 'left',
    fontWeight: 'normal',
    maxWidth: '235px',
  },
  '& .icon-right': {
    float: 'right',
    color: '#0078D4',
  },
});

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
const gmcToMMCMappingGridStyles = ({ iconFontFamily, palette }) => ({
  marginTop: '24px',
  overflowY: 'hidden',
  overflowX: 'auto',
  // Sets DetailsList to trigger a vertical scrollbar at > 5 rows
  // Also supports horizontal scrollbar for the grid during resizing of the browser
  '& .ms-DetailsList-contentWrapper': {
    maxHeight: '240px',
    overflowY: 'auto',
    overflowX: 'auto',
    width: 'fit-content',
  },
  '& .ms-DetailsRow-cell': {
    maxWidth: '400px',
  },
  '& .ms-DetailsHeader-cellName p': {
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
});

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
export const draftAlertStyles = ({ iconFontFamily, palette }) => ({
  maxWidth: '1259px',
  '& a': {
    color: '#006ed4',
  },
});

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
export const gmcToMMCMappingGridWithSignInStyles = ({ iconFontFamily, palette }) => ({
  '& .ms-Viewport': {
    maxWidth: '1259px',
  },
  '& .gmc-to-mmc-mapping-grid': gmcToMMCMappingGridStyles({ iconFontFamily, palette }),
  '& .gmc-sign-in-status-section': gmcSignInStatusSectionStyles({ iconFontFamily, palette }),
  '& .draft-store-alert': _.extend(
    draftAlertStyles({ iconFontFamily, palette }),
    { marginTop: '20px' }
  ),
  '& .dropdown-toggle': dropdownStyles({ iconFontFamily, palette }),
  '& .read-only-cell': readOnlyCellStyles({ iconFontFamily, palette }),
  '& .multiple-matching-stores-description':
    multipleMatchingStoresDescriptionStyles({ iconFontFamily, palette }),
  '& .get-mappings-error-text': detailsListGridErrorText(),
});
